import AttachmentField from './FileUpload/AttachmentField';
import WysiwygField from '../Wysiwyg/WsywigField';

export const customFields = {
  attachmentField: AttachmentField,
  wysiwyg: WysiwygField,
};
